import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import DocumentTitle from 'react-document-title';

import 'bootstrap/dist/css/bootstrap.min.css';

import './index.css';

import { ClientDataInputForm } from './Components/ClientDataInputForm.jsx';
import { EmailNotification } from './Components/NotificationPages/EmailNotification.jsx';
import { EmaillValidation, getEmailValidation } from './Components/EmaillValidation.jsx';
import { PaymentSuccess } from './Components/NotificationPages/PaymentSuccess.jsx';
import { ErrorPage } from './Components/ErrorPage.jsx';


function AdamoShopApp() {
  return (
      <DocumentTitle title='Adamo'>
        <ClientDataInputForm></ClientDataInputForm>
      </DocumentTitle>
  )
}

const router = createHashRouter([
  {
      path: "/",
      element: <AdamoShopApp/>,
      errorElement: <ErrorPage/>,
      basename: "/buyadamo.html",
      children: []
  },
  {
    path: "/email-notification",
    element: <EmailNotification/>,
    errorElement: <ErrorPage/>,
    basename: "/buyadamo.html"
  },
  {
    path: "/email-validation/:orderId",
    element: <EmaillValidation/>,
    errorElement: <ErrorPage/>,
    basename: "/buyadamo.html",
    loader: getEmailValidation
  },
  {
    path: "/payment-success",
    element: <PaymentSuccess/>,
    errorElement: <ErrorPage/>,
    basename: "/buyadamo.html"
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
